var _rect, _rect2, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 146,
    viewBox: "0 0 260 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 260,
    height: 146,
    rx: 8.10938,
    fill: "url(#paint0_radial_4154_27229)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 260,
    height: 146,
    rx: 8.10938,
    fill: "url(#paint1_linear_4154_27229)",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M148.562 54.875C150.185 54.875 151.5 56.1902 151.5 57.8125V83.54C151.5 83.5534 151.5 83.5667 151.5 83.5801V88.1875C151.5 89.8098 150.185 91.125 148.562 91.125H143.379C143.364 91.1253 143.35 91.1252 143.335 91.125H111.438C109.815 91.125 108.5 89.8098 108.5 88.1875V57.8125C108.5 56.1902 109.815 54.875 111.438 54.875H148.562ZM140.687 75.9375C140.571 75.9375 140.459 75.9835 140.377 76.0654L135.842 80.5947L143.871 88.625H148.562C148.804 88.625 149 88.4291 149 88.1875V84.0752L140.995 76.0645V76.0654C140.913 75.9837 140.802 75.9376 140.687 75.9375ZM122.406 70.875C122.349 70.875 122.291 70.8862 122.238 70.9082C122.185 70.9302 122.137 70.9624 122.097 71.0029V71.0039L111 82.1006V88.1875C111 88.4291 111.196 88.625 111.438 88.625H140.336L122.716 71.0039V71.0029C122.675 70.9624 122.627 70.9302 122.574 70.9082C122.521 70.8862 122.464 70.875 122.406 70.875ZM111.438 57.375C111.196 57.375 111 57.5709 111 57.8125V78.5654L120.328 69.2363L120.542 69.042C120.765 68.859 121.014 68.7095 121.281 68.5986C121.638 68.4508 122.02 68.375 122.406 68.375C122.792 68.375 123.175 68.4508 123.531 68.5986C123.888 68.7464 124.212 68.9633 124.484 69.2363L134.074 78.8262L138.609 74.2969C139.16 73.7464 139.908 73.4375 140.687 73.4375C141.368 73.4376 142.024 73.6747 142.547 74.1025L142.763 74.2969V74.2979L149 80.5391V57.8125C149 57.5709 148.804 57.375 148.562 57.375H111.438ZM135.906 62.5625C137.304 62.5625 138.438 63.6958 138.438 65.0938C138.438 66.4917 137.304 67.625 135.906 67.625C134.508 67.625 133.375 66.4917 133.375 65.0938C133.375 63.6958 134.508 62.5625 135.906 62.5625Z",
    fill: "#2C2C2C",
    fillOpacity: 0.4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_4154_27229",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(130 73) rotate(90) scale(73 130)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333333",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333",
    stopOpacity: 0.04
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4154_27229",
    x1: 39.1016,
    y1: 150.563,
    x2: 236.4,
    y2: 3.73238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292929",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292929"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/Card.b1f2d3d655c3c5f6f61e7cc3a778a2e8.svg";
export { ForwardRef as ReactComponent };